import React, { useEffect, useRef, useState } from "react";
import { SelectInput, TextInput } from "../components/common/ui/Inputs";
import Button from "../components/common/ui/Button";
import { useDispatch, useSelector } from "react-redux";
import { paymentReportAction, authActions } from "../_store";
import deleteicon from "../assets/svg/delete-icon.svg";
import Table from "../components/common/table/Table";
import ExcelExport from "../components/common/ui/Export/ExcelExport";
import { Popup } from "../components/common/ui/NotificationModal/Popup";
import { showToastNotification } from "../components/common/ui/NotificationModal/ToastNotication";
import generateXlsx from "../components/common/export/generateXlsx";
import CustomLoader from "../components/common/ui/Loader";
import { StoredProcedures } from "../_helpers/enumerator";

function PaymentReport() {
  const inmateLastName = useSelector((x) => x.paymentReport.InmateLastName);
  const inmateFirstName = useSelector((x) => x.paymentReport.InmateFirstName);
  const publicUserLastName = useSelector(
    (x) => x.paymentReport.PublicUserLastName
  );
  const publicUserFirstName = useSelector(
    (x) => x.paymentReport.PublicUserFirstName
  );
  const isPageReloading = useSelector((state) => state.master?.isPageReload);

  const { user, commonFacilityCode } = useSelector((x) => x.auth);

  const deleteResponse = useSelector((x) => x.paymentReport.deletedata);
  const {
    PaymentReportList: gridData,
    PaymentReportFullList: exceldata,
    loading,
  } = useSelector((x) => x.paymentReport);

  const { paymentTypeOptions, statusOption } = useSelector(
    (x) => x.dropdownOptions
  );

  const [payment, setPayment] = useState({
    InmateResidentId: "",
    InmateLastName: "",
    InmateLastNameKey: 0,
    InmateFirstName: "",
    InmateFirstNameKey: 0,
    PublicUserLastName: "",
    PublicUserLastNameKey: 0,
    PublicUserFirstName: "",
    PublicUserFirstNameKey: 0,
    POTransactionRandomID: "",
    PaymentTransactionID: "",
    PaymentType: "All",
    activeStatus: 1,
    pageNo: 1,
    rowCountPerPage: 10,
    sortField: "",
  });

  let paymentSearch = { ...payment };
  const [showSearchFields, setShowSearchFields] = useState(false);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(paymentReportAction.LoadInmateLastNames({ firstName: "" }));
    dispatch(paymentReportAction.LoadInmateFirstNames({ lastName: "" }));
    dispatch(paymentReportAction.LoadPublicUserLastNames({ firstName: "" }));
    dispatch(paymentReportAction.LoadPublicUserFirstNames({ lastName: "" }));
    dispatch(paymentReportAction.LoadDuplicatePaymentTransaction(payment));
  }, [dispatch, isPageReloading]);

  // useEffect(() => {
  //   dispatch(paymentReportAction.LoadDuplicatePaymentTransaction(payment));
  // }, [payment.pageNo, payment.rowCountPerPage]);

  //Grid Column

  // const Column = [
  //   {
  //     name: "Inmate ID",
  //     selector: (row) => row.InmateResidentId,
  //     sortable: true,
  //   },
  //   {
  //     name: "Inmate Full Name",
  //     selector: (row) => row.InmateFullName,
  //     sortable: true,
  //   },
  //   {
  //     name: "Public User Full Name",
  //     selector: (row) => row.PublicUserFullName,
  //     sortable: true,
  //   },
  //   {
  //     name: "Amount ($)",
  //     selector: (row) => row.PurchaseAmount.toFixed(2),
  //     sortable: true,
  //   },
  //   {
  //     name: "Order ID",
  //     selector: (row) => row.POTransactionRandomID,
  //     sortable: true,
  //   },
  //   {
  //     name: "Transaction ID",
  //     selector: (row) => row.PaymentTransactionID,
  //     sortable: true,
  //   },
  //   {
  //     name: "Payment Type",
  //     selector: (row) => row.PaymentType,
  //     sortable: true,
  //   },
  //   {
  //     name: "Status",
  //     //selector: (row) => row.PaymentStatus,
  //     selector: (row) =>
  //       row.PaymentStatus === "Payment complete." ? "Close" : "Open",
  //     sortable: true,
  //   },
  //   {
  //     name: "Created Date",
  //     selector: (row) => row.CreatedDate,
  //     sortable: true,
  //   },
  //   {
  //     name: "Action",
  //     selector: (row) => (
  //       <div style={{ display: "flex", gap: "10px" }}>
  //         <img
  //           src={deleteicon}
  //           className="fa fa-trash"
  //           alt="Delete"
  //           aria-hidden="true"
  //           onClick={() => {
  //             handleDelete(row.DuplicatePaymentTransactionID);
  //           }}
  //           style={{ cursor: "pointer", color: "red" }}
  //         />
  //       </div>
  //     ),
  //     sortable: true,
  //   },
  // ];

  const Column = [
    {
      width: "110px",
      name: "Inmate ID",
      selector: (row) => row.InmateResidentId,
      sortable: true,
      key: "InmateResidentId",
    },
    {
      name: "Inmate Full Name",
      selector: (row) => row.InmateFullName,
      sortable: true,
      key: "InmateFullName",
    },
    {
      name: "Public User Full Name",
      selector: (row) => row.PublicUserFullName,
      sortable: true,
      key: "PublicUserFullName",
    },
    {
      width: "100px",
      name: "Amount ($)",
      selector: (row) => row.PurchaseAmount.toFixed(2),
      sortable: true,
      key: "PurchaseAmount",
    },
    {
      name: "Order ID",
      selector: (row) => row.POTransactionRandomID,
      sortable: true,
      key: "POTransactionRandomID",
    },
    {
      name: "Transaction ID",
      selector: (row) => row.PaymentTransactionID,
      sortable: true,
      key: "PaymentTransactionID",
    },
    {
      width: "100px",
      name: "Payment Type",
      selector: (row) => row.PaymentType,
      sortable: true,
      key: "PaymentType",
    },
    {
      width: "75px",
      name: "Status",
      //selector: (row) => row.PaymentStatus,
      selector: (row) => (row.IsActive === false ? "Closed" : "Open"),
      sortable: true,
    },
    {
      name: "Created Date",
      selector: (row) => row.CreatedDate,
      cell: (row) => (
        <div className="d-flex flex-wrap ">
          <div className="font-size-13 fw-500 ">{row.CreatedDate}</div>
        </div>
      ),
      sortable: true,
      key: "CreatedDate",
    },
    {
      width: "70px",
      name: "Action",
      selector: (row) => row.DuplicatePaymentTransactionID,

      cell: (row) => (
        <div className="d-flex flex-wrap justify-content-center align-items-center h-100">
          <img
            src={deleteicon}
            className="fa fa-trash"
            alt="Delete"
            title="Delete"
            aria-hidden="true"
            onClick={() => {
              handleDelete(row.DuplicatePaymentTransactionID);
            }}
            style={{ cursor: "pointer", color: "red" }}
          />
        </div>
      ),
      sortable: false,
    },
  ];

  const handleSelectChange = (selectedOptions, name) => {
    switch (name) {
      case "activeStatus":
        paymentSearch[name] = selectedOptions?.value ?? 1;
        break;

      case "InmateFirstName":
        paymentSearch.InmateFirstNameKey = selectedOptions?.value || 0;
        paymentSearch[name] = selectedOptions
          ? selectedOptions?.label === "Select"
            ? ""
            : selectedOptions?.label
          : "";
        break;

      case "InmateLastName":
        paymentSearch.InmateLastNameKey = selectedOptions?.value || 0;
        paymentSearch[name] = paymentSearch[name] = selectedOptions
          ? selectedOptions?.label === "Select"
            ? ""
            : selectedOptions?.label
          : "";
        break;

      case "PublicUserLastName":
        paymentSearch.PublicUserLastNameKey = selectedOptions?.value || 0;
        paymentSearch[name] = paymentSearch[name] = selectedOptions
          ? selectedOptions?.label === "Select"
            ? ""
            : selectedOptions?.label
          : "";
        break;

      case "PublicUserFirstName":
        paymentSearch.PublicUserFirstNameKey = selectedOptions?.value || 0;
        paymentSearch[name] = paymentSearch[name] = selectedOptions
          ? selectedOptions?.label === "Select"
            ? ""
            : selectedOptions?.label
          : "";
        break;

      case "PaymentType":
        paymentSearch[name] = selectedOptions?.label
          ? selectedOptions?.label
          : "All";
        break;

      default:
        showToastNotification("Unhandled case for name:", "error");
    }

    setPayment({ ...paymentSearch, pageNo: 1, rowCountPerPage: 10 });

    dispatch(
      paymentReportAction.LoadDuplicatePaymentTransaction({
        ...paymentSearch,
        pageNo: 1,
        rowCountPerPage: 10,
      })
    );
  };

  // OnChnage Func
  const handleChange = (e) => {
    let { name, value } = e?.target;

    // Allow only numeric input
    if (name === "InmateResidentId" && /[^0-9]/g.test(value)) {
      return; // Exit if the value contains anything other than numbers
    }

    setPayment((prev) => ({
      ...prev,
      [name]: value.trim(),
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const search = { ...payment, pageNo: 1, rowCountPerPage: 10 };
    setPayment(search);
    dispatch(paymentReportAction.LoadDuplicatePaymentTransaction(search));
  };

  // Reset the Serach box
  const handleReset = () => {
    let param = {
      InmateResidentId: "",
      InmateLastName: "",
      InmateLastNameKey: 0,
      InmateFirstName: "",
      InmateFirstNameKey: 0,
      PublicUserLastName: "",
      PublicUserLastNameKey: 0,
      PublicUserFirstName: "",
      PublicUserFirstNameKey: 0,
      POTransactionRandomID: "",
      PaymentTransactionID: "",
      PaymentType: "All",
      activeStatus: 1,
      pageNo: 1,
      rowCountPerPage: 10,
      sortField: "",
    };

    setPayment(param);

    dispatch(paymentReportAction.LoadDuplicatePaymentTransaction(param));
  };

  const handlePageChangeUser = (value) => {
    if (sorting) {
      sorting = false;
      return;
    }
    setPayment((prev) => ({
      ...prev,
      pageNo: value,
    }));
    dispatch(paymentReportAction.LoadDuplicatePaymentTransaction({ ...payment, pageNo: value, }));
  }; // Call API when page changes
  const handleRowsPerPageChangeUser = (value) => {
    setPayment((prev) => ({
      ...prev,
      rowCountPerPage: value,
      pageNo: 1,
    }));
    dispatch(paymentReportAction.LoadDuplicatePaymentTransaction({ ...payment, pageNo: 1, rowCountPerPage: value, }));
  };

  //   //For Excel and PDF

  const handleClickExcel = () => {
    // Define the title and column headers for the Excel file
    const updateTotalRows = {
      ...payment,
      pageNo: 1,
      RowCountPerPage: gridData?.TotalRecordCount,
      exportExcel: true, // Flag to indicate Excel export
    };

    // Dispatch action to load the full list for Excel export
    dispatch(
      paymentReportAction.LoadDuplicatePaymentTransaction(updateTotalRows)
    );
  };

  // UseEffect to detect when exceldata is populated and trigger the Excel export
  useEffect(() => {
    if (exceldata && exceldata?.DataList?.length > 0) {
      const title = "PaymentReport";
      const generateExcelColumns = [
        "Inmate ID",
        "Inmate Full Name",
        "Public User Full Name",
        "Amount ($)",
        "Order ID",
        "Transaction ID",
        "Payment Type",
        "Status",
        "Created Date",
      ];

      // Map the data to match the Excel format
      const new_DuplicatePaymentReport =
        exceldata?.DataList?.map((obj) => ({
          InmateResidentId: obj.InmateResidentId,
          InmateFullName: obj.InmateFullName,
          PublicUserFullName: obj.PublicUserFullName,
          PurchaseAmount: String(obj.PurchaseAmount.toFixed(2)),
          POTransactionRandomID: obj.POTransactionRandomID,
          PaymentTransactionID: obj.PaymentTransactionID,
          PaymentType: obj.PaymentType,
          PaymentStatus: obj?.IsActive ? "Open" : "Closed",
          CreatedDate: obj.CreatedDate,
        })) || [];

      // Generate the Excel file with the transformed data
      try {
        generateXlsx(new_DuplicatePaymentReport, generateExcelColumns, title);
        dispatch(paymentReportAction.clearPaymentReportFullList());
      } catch (error) {
        console.error("Error generating Excel file:", error);
      }
    }
  }, [exceldata]); // This will trigger whenever exceldata is updated

  const handleDelete = (DuplicatePaymentTransactionID) => {
    // const payload = {
    //   DuplicatePaymentTransactionID: DuplicatePaymentTransactionID,
    // };

    if (DuplicatePaymentTransactionID > 0) {
      Popup({
        title: "Message",
        text: `Are you sure you want to delete?`,
        icon: "info",
        confirmButtonText: "Ok",
        cancelButtonText: "Cancel",
        onConfirm: () => {
          dispatch(
            paymentReportAction.DeleteDuplicatePayment(
              DuplicatePaymentTransactionID
            )
          ).then((deleteResponse) => {
            switch (deleteResponse?.payload.IsSucceed) {
              case 1:
                const searchParams = { ...payment };
                // searchParams.pageNo = 1;
                // searchParams.rowCountPerPage = 10;
                // setPayment(searchParams);
                dispatch(
                  paymentReportAction.LoadDuplicatePaymentTransaction(
                    searchParams
                  )
                )
                  .then((result) => {
                    if (result?.payload?.DataList?.length === 0) {
                      const searchData = { ...payment };
                      searchData.pageNo = 1;
                      searchData.rowCountPerPage = 10;
                      setPayment(searchData);
                      dispatch(
                        paymentReportAction.LoadDuplicatePaymentTransaction(
                          searchData
                        )
                      );
                    }
                  })
                  .catch((err) => {
                    showToastNotification("Failed to load data", "error");
                  });
                showToastNotification("Deleted successfully", "success");
                //dispatch(paymentReportAction.clearDeleteDocument());
                break;

              case -1:
                showToastNotification("Failed to Delete", "error");
                //dispatch(paymentReportAction.clearDeleteDocument());
                break;

              case -2:
                showToastNotification("Document is not available", "error");
                //dispatch(paymentReportAction.clearDeleteDocument());
                break;

              default:
                break;
            }
          });
          // Insert Management User Activity Log
          dispatch(
            authActions?.ManagementUserActivityLog({
              ManagementUserID: user?.ManagementUserID,
              facilityID: commonFacilityCode,
              ProcedureName: StoredProcedures?.DeleteStripeDuplicatePayment,
              UserAction: `Delete Duplicate Payment ( DuplicatePaymentTransactionID - ${DuplicatePaymentTransactionID})`,
            })
          );
        },
      });
    }
  };

  if (loading) {
    return <CustomLoader />;
  }

  let sorting = false;
  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;
    sorting = true;
    const search = { ...payment };
    const newSortOrder = search.sortField?.includes(column.key)
      ? search.sortField.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";
    search.sortField = `${column.key} ${newSortOrder}`;
    setPayment(search);
    dispatch(
      paymentReportAction.LoadDuplicatePaymentTransaction({
        ...payment,
        sortField: `${column.key} ${newSortOrder}`,
      })
    );
  };

  const toggleInformation = () => {
    setShowSearchFields((prev) => !prev);
  };

  const renderSearch = () => {
    return (
      <form onSubmit={handleSubmit}>
        {/* First Row: Inmate ID, Inmate Last Name, Inmate First Name */}
        <div className="row">
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="InmateResidentId"
                id="InmateResidentId"
                label="Inmate ID"
                value={paymentSearch?.InmateResidentId}
                handleChange={handleChange}
                placeholder="Enter Inmate ID"
                required={false}
                autoComplete="off" // Disable autocomplete
                maxLength={18}
              //   errorMessage={errorMessage}
              ></TextInput>
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              {/* Inmate Last Name */}
              <SelectInput
                options={inmateLastName}
                value={paymentSearch?.InmateLastNameKey}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "InmateLastName")
                }
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                isClearable={paymentSearch?.InmateLastNameKey}
                placeholder="Select"
                label="Inmate Last Name"
                name={"InmateLastName"}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              {/* Inmate First Name */}
              <SelectInput
                options={inmateFirstName}
                value={paymentSearch?.InmateFirstNameKey}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "InmateFirstName")
                }
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                isClearable={paymentSearch?.InmateFirstNameKey}
                placeholder="Select"
                label="Inmate First Name"
                name={"InmateFirstName"}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              {/* Public User Last Name */}
              <SelectInput
                options={publicUserLastName}
                value={paymentSearch?.PublicUserLastNameKey}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "PublicUserLastName")
                }
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                isClearable={paymentSearch?.PublicUserLastNameKey}
                placeholder="Select"
                label="Public User Last Name"
                name={"PublicUserLastName"}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              {/* Public User First Name */}
              <SelectInput
                options={publicUserFirstName}
                value={paymentSearch?.PublicUserFirstNameKey}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "PublicUserFirstName")
                }
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                isClearable={paymentSearch?.PublicUserFirstNameKey}
                placeholder="Select"
                label="Public User First Name"
                name={"PublicUserFirstName"}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              {/* State */}
              <SelectInput
                options={paymentTypeOptions}
                value={paymentSearch?.PaymentType} // This is the selected value (e.g., 0, 1)
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "PaymentType")
                }
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                isClearable={paymentSearch?.PaymentType !== "All"}
                placeholder="Select"
                label="Payment Type"
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="POTransactionRandomID"
                id="POTransactionRandomID"
                label="Order ID"
                value={paymentSearch.POTransactionRandomID}
                handleChange={handleChange}
                placeholder="Enter Order ID"
                required={false}
                autoComplete="off" // Disable autocomplete
              //   errorMessage={errorMessage}
              ></TextInput>
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="PaymentTransactionID"
                id="PaymentTransactionID"
                label="Transaction ID"
                value={paymentSearch.PaymentTransactionID}
                handleChange={handleChange}
                placeholder="Transaction ID"
                required={false}
                autoComplete="off" // Disable autocomplete
              //   errorMessage={errorMessage}
              ></TextInput>
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              {/* State */}
              <SelectInput
                options={statusOption}
                value={paymentSearch?.activeStatus} // This is the selected value (e.g., 0, 1)
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "activeStatus")
                }
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                isClearable={paymentSearch?.activeStatus !== 1}
                placeholder="Select"
                label="Status"
              />
            </div>
          </div>
        </div>
        {/* Buttons */}
        <div className="mt-3 d-flex flex-wrap justify-content-center gap-3">
          <Button
            // variant="danger"
            className="me-2"
            label={"SEARCH"}
            type={"submit"}
            status={"primary"}
            disabled={false}
            icon={"search"}
          ></Button>
          <Button
            variant="danger"
            className="me-2"
            onClick={handleReset} // This will now work correctly
            label={"RESET"}
            type={"button"}
            status={"secondary"}
            disabled={false}
            icon={"fa-solid fa-rotate-right"}
          />
        </div>
      </form>
    );
  };

  return (
    <>
      <div className="PaymentReport">
        <div className="d-flex flex-wrap flex-column justify-content-center align-items-center position-relative">
          <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100">
            {/* Mobile only (Below md breakpoint) */}
            <div className=" d-block d-md-none">
              <div
                className=" d-flex align-items-center justify-content-between"
                style={{ background: "transparent", cursor: "pointer" }}
                onClick={toggleInformation}
              >
                <h2 className="form_title_uppercase text-color">
                  DUPLICATE PAYMENTS SEARCH
                </h2>
                <i
                  id="itagInformation"
                  className={`fa fa-angle-down ${showSearchFields ? "rotate" : ""
                    }`}
                  style={{ fontSize: "20px" }}
                ></i>
              </div>
            </div>
            {/* Mobile only (Below md breakpoint) */}
            <div className="d-block d-md-none mt-2">
              {showSearchFields && renderSearch()}
            </div>

            {/* Web only (Desktop and above) */}
            <div className="mb-3 d-none d-md-block">
              <h2 className="form_title_uppercase text-color">
                DUPLICATE PAYMENTS SEARCH
              </h2>
            </div>
            {/* Web only (Desktop and above) */}
            <div className="d-none d-md-block">{renderSearch()}</div>
          </div>
          <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100 mb-4">
            <div className="d-flex flex-wrap justify-content-between align-items-center mb-2 resp-space">
              <h2 className="text-color">DUPLICATE PAYMENTS LIST</h2>
              {gridData?.DataList?.length > 0 && (
                <ExcelExport handleExcelExport={handleClickExcel} />
              )}
            </div>
            <Table
              // title={"Registered Users"}
              columns={Column}
              data={gridData?.DataList}
              pagination={true}
              onChangePage={(e) => handlePageChangeUser(e)} // Call API when page changes
              onChangeRowsPerPage={(e) => handleRowsPerPageChangeUser(e)}
              totalRowCount={gridData?.TotalRecordCount}
              currentPage={payment?.pageNo}
              paginationPerPage={payment.rowCountPerPage}
              onSort={handleSort}
              serverSideSort
              sortColumn={payment?.sortField?.split(" ")[0]}
              sortDirection={payment?.sortField?.split(" ")[1]}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default React.memo(PaymentReport);
